import lazyLoad from 'app/shared-components/util/lazyLoad';

const ResendConfirmationPage = lazyLoad(() => import('./ResendConfirmationPage'));
import authRoles from '../../auth/authRoles';

const ResendConfirmationConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: 'resend-code',
      element: <ResendConfirmationPage />,
    },
  ],
};

export default ResendConfirmationConfig;
